import React, { FC } from "react";
import { useTheme } from "@material-ui/core";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const NetEarningsIcon: FC<SvgIconProps> = props => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const secondary = theme.palette.secondary.main;

  return (
    <SvgIcon {...props} width="54" height="54" viewBox="0 0 54 54">
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <g>
          <path
            stroke={primary}
            d="M0 15.902V5.444C0 3.542 1.555 2 3.474 2h45.052C50.445 2 52 3.542 52 5.444v34.112C52 41.458 50.445 43 48.526 43H29.57M1 10L52 10"
            transform="translate(1)"
          />
          <path
            stroke={secondary}
            d="M8 0L8 4M34 19L35 19M43 19L44 19M34 25L35 25M43 25L44 25M34 31L35 31M43 31L44 31M26 19L27 19M14 0L14 4M21 0L21 4M26 0L26 4M31 0L31 4M37 0L37 4M44 0L44 4M34 37L35 37M34 14L35 14M43 14L44 14M26 14L27 14M18 14L19 14M8 14L9 14"
            transform="translate(1)"
          />
        </g>
        <g>
          <path
            stroke={primary}
            d="M23 25.415C23 26.843 21.712 28 20.125 28H2.875C1.287 28 0 26.843 0 25.415V6.031L5.75 0h14.375C21.712 0 23 1.158 23 2.585v22.83z"
            transform="translate(1 25)"
          />
          <path stroke={primary} d="M6 0L6 6 0 6" transform="translate(1 25)" />
          <g stroke={secondary}>
            <path
              d="M3 7C1.344 7 0 5.88 0 4.5S1.344 2 3 2s3 1.12 3 2.5M3 7c1.656 0 3 1.12 3 2.5S4.656 12 3 12s-3-1.12-3-2.5M3 2L3 0M3 14L3 12"
              transform="translate(1 25) translate(10 7)"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default NetEarningsIcon;
